var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 592.376,
    height: 748.833,
    viewBox: "0 0 592.376 748.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(3420.139 -6204.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_accept_terms_re_lj38",
    transform: "translate(-3607 6041.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M874.108,537.431a15.7,15.7,0,0,1-9.75,11.261c-1.248.469-.356,2.337.884,1.87a17.59,17.59,0,0,0,10.813-12.434,1.069,1.069,0,0,0-.625-1.323,1.039,1.039,0,0,0-1.322.625Z",
    transform: "translate(-96.87 61.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M728.891,376.669Z",
    transform: "translate(-197.573 -57.847)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 124.189,
    cy: 124.189,
    r: 124.189,
    transform: "translate(186.861 223.071)",
    fill: "teal"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M612.021,463.055c-.268,0-.54-.006-.811-.019a16.541,16.541,0,0,1-12.258-6.371L579.378,431.5a16.572,16.572,0,0,1,2.9-23.231l.7-.546a16.581,16.581,0,0,1,23.237,2.9,9.929,9.929,0,0,0,7.36,3.825,9.74,9.74,0,0,0,7.7-3.089l39.741-41.951a16.575,16.575,0,0,1,23.4-.633l.646.611a16.573,16.573,0,0,1,.636,23.4l-61.67,65.1a16.527,16.527,0,0,1-12.013,5.169Z",
    transform: "translate(-311.812 -67.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M655.874,503.552A124.163,124.163,0,0,1,532.029,388.145c-.2,2.851-.344,5.76-.344,8.7a124.189,124.189,0,0,0,248.378,0c0-2.942-.14-5.851-.341-8.742A124.172,124.172,0,0,1,655.874,503.552Z",
    transform: "translate(-344.824 -49.308)",
    fill: "#231f20",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M479.182,306.231l98.483,4.019,12.059-66.327L505.309,217.8Z",
    transform: "translate(6.954 141.24)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M796.02,402.573l.953-31.335-47.731-11.966L663.307,334.2a17.94,17.94,0,1,0-9.575,21.93l83.544,34.342Z",
    transform: "translate(-272.661 -98.759)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M706.725,384.322l26.852-38.3.67.089c.421.056,42.529,5.689,70.134,13.909A22.067,22.067,0,0,1,818.67,371.9a23.145,23.145,0,0,1-3.219,25.169,24.755,24.755,0,0,1-25.443,8.454Z",
    transform: "translate(-214.124 -80.728)",
    fill: "teal"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M509.852,563.495H482.539l-12.994-105.35h40.31Z",
    transform: "translate(-0.241 320.705)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M638.143,556.219,611.138,560.3l-28.6-102.223,35.4-6.024Z",
    transform: "translate(84.131 316.157)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M818.532,447.99l-94.465-16.079-3.36,6.925a320.784,320.784,0,0,0-31.434,119.146c-2.281,34.927-3.623,71.815-3.667,110.485-.068,59.913,2.989,115.506,7.822,166.091l51.845-.325a1224.53,1224.53,0,0,1,6.1-160.9c3.968-38.107,9.485-73.7,15.865-106.548A732.943,732.943,0,0,0,817.1,706.742c18.118,38.315,55.384,82.6,73.5,120.918l55.7-6.684c-14.631-38.691-40.731-95.191-55.362-133.882-20.919-55.321-30.368-92.832-51.287-148.152a170.513,170.513,0,0,0,.7-31.329c-.974-17.4-4.595-38.29-15.177-52.214Z",
    transform: "translate(-229.893 -16.599)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M816.236,483.454c4.717,8.818-6.486,27.086-14.594,28.837l-93.415-30.2,47.036-136.3,23.665,4.3,37.848,6.377,13.425,12.2a23.6,23.6,0,0,1,6.51,24.913Z",
    transform: "translate(-213.003 -80.9)",
    fill: "teal"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M796.741,401.659l-26.427-16.864-34.72,34.87-65.54,60.975a17.94,17.94,0,1,0,13.934,19.454l72.279-54.173Z",
    transform: "translate(-257.814 -51.78)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M732.306,453.375,713.161,410.7l.419-.53c.264-.333,26.666-33.617,47.862-53.118a22.067,22.067,0,0,1,17.522-6.189,23.157,23.157,0,0,1,19.971,15.653,24.753,24.753,0,0,1-5.767,26.182Z",
    transform: "translate(-209.318 -77.19)",
    fill: "teal"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 41.546,
    cy: 41.546,
    r: 41.546,
    transform: "translate(540.99 172.696)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M814.594,399.039l-.159-.04L754.06,383.9a13.8,13.8,0,0,1-8.483-20.5l1.994-3.318a22.637,22.637,0,0,0,.926-21.622,23.831,23.831,0,0,0-13.7-11.7l-.2-.1-1.268-.789a9.893,9.893,0,0,1-5.237-6.051,10.207,10.207,0,0,1,1-8.231,49.951,49.951,0,0,1,22.819-20.118,51.516,51.516,0,0,1,37.864-1.137,6.724,6.724,0,0,1,6.183-1.571c31.267,7.572,33.84,28.559,27.663,62.249L830.93,380.5a14.774,14.774,0,0,1-13.18,18.288ZM789.439,290.67Zm.754-.185h.006Z",
    transform: "translate(-198.505 -124.596)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M752.819,739.34H737.231l-2.782-14.717-7.126,14.717H685.98a9.294,9.294,0,0,1-5.28-16.94l33.015-22.8V684.719l34.726,2.073Z",
    transform: "translate(-236.554 172.17)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M873.251,739.34H857.663l-2.782-14.717-7.126,14.717H806.412a9.294,9.294,0,0,1-5.281-16.941l33.015-22.8v-14.88l34.726,2.073Z",
    transform: "translate(-146.629 172.17)",
    fill: "#2f2e41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.85b1df40f255dc69cfdb49d0bd991f80.svg";
export { ForwardRef as ReactComponent };